import { FC, Fragment, useContext, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import LoaderMain from 'components/shared/LoaderMain';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/sharp-duotone-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { MainContext } from 'contexts/MainContext';
import { b2b, imgLoaderMain, defaultLoaderUrl } from 'constants/generic';

const DetailSkeleton: FC = () => {
  return (
    <Fragment>
      <div className="details-wrapper hotel-details-wrapper">
        <div className="details-summary default-shadow">
          <div className="mb-10">
            <Skeleton height={23} width={130} />
          </div>
          <div className="mb-20">
            <Skeleton height={20} width={80} />
          </div>
          <div className="mb-10">
            <Skeleton height={23} width={150} />
          </div>
          {Array(4)
            .fill(0)
            .map((_, index) => (
              <div className="mb-5" key={index}>
                <Skeleton height={16} width={190} />
              </div>
            ))}
          <div className="mb-20"></div>
          <div className="mb-10">
            <Skeleton height={23} width={'100%'} />
          </div>
          <div className="mb-10">
            {Array(4)
              .fill(0)
              .map((_, index) => (
                <div className="mb-5" key={index}>
                  <Skeleton height={16} width={200} />
                </div>
              ))}
          </div>
        </div>
        <div className="details">
          <div className="details-slider default-shadow">
            <div className="details-slider-header">
              <div>
                <div className="title">
                  <Skeleton width={200} height={20} />
                </div>
                <div className="subtitle">
                  <Skeleton width={220} height={16.5} />
                </div>
              </div>
              <Skeleton width={100} height={20} />
            </div>
            <div className="details-slider-images">
              <div className="slider-main-image">
                <Skeleton width={'100%'} height={'100%'} />
              </div>
              <div className="slider-images">
                {Array(3)
                  .fill(0)
                  .map((_, index) => (
                    <div key={index} className="slider-image">
                      <Skeleton width={'100%'} height={'100%'} />
                    </div>
                  ))}
              </div>
            </div>
          </div>

          <div className="details-block default-shadow">
            <div className="mb-20">
              <Skeleton height={23} width={190} />
            </div>
            <div>
              <Skeleton height={300} width={'100%'} />
            </div>
          </div>

          <div className="details-block default-shadow">
            <div className="mb-20">
              <Skeleton height={23} width={190} />
            </div>
            <div>
              <Skeleton height={300} width={'100%'} />
            </div>
          </div>

          <RoomDetailsSkeleton />
        </div>
      </div>
      
        <LoaderMain systemProducts="Hotels" systemProductsDetails="LoadingDetails" />
      
    </Fragment>
  );
};

export default DetailSkeleton;

export const RoomDetailsSkeleton: FC = () => {
  const {
    cdnUrl,
    isEnigma,
    initSiteData
  } = useContext(MainContext);
  const [loading, setLoading] = useState<any>();
  const {
    t } = useTranslation();
  useEffect(() => {
    const allLoading = JSON.parse(localStorage.getItem('allLoadings') || '{}');
    const newLoading = allLoading?.loadings?.find(
      (item: any) =>
        item.loadingPage.systemProducts === 'Hotels' &&
        item.loadingPage.systemProductsDetails === 'LoadingDetails'
    );

    setLoading(newLoading);
  }, []);
  return (
    <div className="details-block default-shadow">
      <div className="mb-20">
        <Skeleton height={23} width={190} />
      </div>
      <div className="position-relative w100p" style={{ height: 300 }}>
        <Skeleton height={'100%'} width={'100%'} />
        {b2b && (
          <div className="rooms-rates-loader rooms-rates-loader--overlay">
            <div className="title">{t('hotel.we_are_checking_for_better_rates')}</div>
            <img
              alt="logo"
              src={(cdnUrl || '') + (isEnigma ? initSiteData?.other?.logoUrl || '' : initSiteData?.other?.mainLoaderUrl || initSiteData?.other?.defaultLoaderUrl || defaultLoaderUrl || '')}
            />
            <FontAwesomeIcon icon={faSpinnerThird as any} spinPulse />
          </div>
        )}
        {!!loading && !b2b && (
          <div
            style={{
              position: 'absolute',
              top: 20,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div className="text-lh text-center">
              <div className="title">{t('hotel.we_are_checking_for_better_rates')}</div>
            </div>

            {!!loading.loadingPage.listOfGalleryId?.[0]?.code && (
              <img
                style={{ maxHeight: 200, maxWidth: '100%', objectFit: 'contain' }}
                src={cdnUrl + '/backend' + loading.loadingPage.listOfGalleryId[0].code}
                alt="load"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
interface RoomDetailsPollingProps {
  noChoosenRoom: boolean;
}

export const RoomDetailsPolling: FC<RoomDetailsPollingProps> = ({ noChoosenRoom }) => {
  const [loading,
    setLoading] = useState<any>();
  const { cdnUrl,
    isEnigma,
    initSiteData
  } = useContext(MainContext);
  const { t } = useTranslation();
  useEffect(() => {
    const allLoading = JSON.parse(localStorage.getItem('allLoadings') || '{}');
    const newLoading = allLoading?.loadings?.find(
      (item: any) =>
        item.loadingPage.systemProducts === 'Hotels' &&
        item.loadingPage.systemProductsDetails === 'LoadingDetails'
    );

    setLoading(newLoading);
  }, []);
  return (
    <div className="position-relative w100p" style={{ height: 200 }}>
      {!loading && !!imgLoaderMain && (
        <div className="rooms-rates-loader rooms-rates-loader--overlay">
          {noChoosenRoom && (
            <div className="title">{t('hotel.we_are_waiting_for_the_chosen_room')}</div>
          )}
          <img
            alt="logo"
            src={(cdnUrl || '') + (isEnigma ? initSiteData?.other?.logoUrl || '' : initSiteData?.other?.mainLoaderUrl || initSiteData?.other?.defaultLoaderUrl || defaultLoaderUrl || '')}
          />
          <FontAwesomeIcon icon={faSpinnerThird as any} spinPulse />
        </div>
      )}
      {!!loading && (
        <div
          style={{
            position: 'absolute',
            top: 20,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {noChoosenRoom && (
            <div className="text-lh text-center">
              <div className="title">{t('hotel.we_are_waiting_for_the_chosen_room')}</div>
            </div>
          )}
          {!!loading.loadingPage.listOfGalleryId?.[0]?.code && (
            <img
              style={{ maxHeight: 200, maxWidth: '100%', objectFit: 'contain' }}
              src={cdnUrl + '/backend' + loading.loadingPage.listOfGalleryId[0].code}
              alt="load"
            />
          )}
        </div>
      )}
    </div>
  );
};
